module.exports = __webpack_public_path__ + "static/media/operating-unit.85f6c17b.svg";